import {
  parseDateString,
  toDateString
} from "./chunk-R3PZXXJP.mjs";

// src/calendarDays.ts
var isSameDay = (a, b) => a === b;
var isToday = (d) => d === toDateString(/* @__PURE__ */ new Date());
var isInRange = (d, a, b) => {
  if (!a || !b) return false;
  const lo = a < b ? a : b;
  const hi = a < b ? b : a;
  return d > lo && d < hi;
};
var dayOfDate = (dateStr) => parseInt(dateStr.slice(8, 10), 10);
var addDaysToDateString = (dateStr, days) => {
  const { year, month, day } = parseDateString(dateStr);
  const date = new Date(year, month - 1, day + days);
  return toDateString(date);
};
function getCalendarDays(year, month) {
  const firstDay = (new Date(year, month, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [];
  for (let i = 0; i < firstDay; i++) days.push({ date: null, current: false });
  for (let d = 1; d <= daysInMonth; d++) {
    const mm = String(month + 1).padStart(2, "0");
    const dd = String(d).padStart(2, "0");
    days.push({ date: `${year}-${mm}-${dd}`, current: true });
  }
  return days;
}

export {
  isSameDay,
  isToday,
  isInRange,
  dayOfDate,
  addDaysToDateString,
  getCalendarDays
};
